/* redirect-to-cart.js — leitet nach Add-to-Cart auf /cart um (Produktseite & Quick-Add) */
(function () {
  function isCheckoutSubmitter(submitter) {
    if (!submitter) return false;
    const n = (submitter.getAttribute('name') || '').toLowerCase();
    const id = (submitter.id || '').toLowerCase();
    const txt = (submitter.textContent || '').toLowerCase();
    return n === 'checkout' || id.includes('checkout') || txt.includes('buy it now') || txt.includes('jetzt kaufen');
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Nur echte Add-to-Cart-Forms
    if (!form.matches('form[action*="/cart/add"]') || form.dataset.noRedirect === 'true') return;

    // „Buy it now“ nicht abfangen
    if (isCheckoutSubmitter(e.submitter)) return;

    e.preventDefault();
    const fd = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
    .then(async (res) => {
      if (!res.ok) {
        let msg = 'Es gab ein Problem beim Hinzufügen zum Warenkorb.';
        try {
          const data = await res.json();
          if (data && (data.description || data.message)) msg = data.description || data.message;
        } catch (_) {}
        alert(msg);
        return;
      }
      window.location.assign('/cart');
    })
    .catch(() => alert('Netzwerkfehler: Bitte versuche es erneut.'));
  }, true);
})();
